import React from 'react';
import PropTypes from 'prop-types';
import { ClassNames } from '@emotion/core';
import { withTheme } from 'emotion-theming';
import { RouterLink } from '..';

const propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  large: PropTypes.bool,
  match: PropTypes.bool.isRequired,
  theme: PropTypes.shape({
    borderColor_theme_focus: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    color_theme: PropTypes.string.isRequired,
    color_theme_focus: PropTypes.string.isRequired,
    color_theme_hover: PropTypes.string.isRequired,
    color_theme_active: PropTypes.string.isRequired,
    fontSize_base: PropTypes.string.isRequired,
    space_inset_md: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
  large: false,
};

function NavigationLink({
  children,
  href,
  large,
  match,
  theme,
}) {
  /* We pass a className so that we can style the underlying router link
   * Do not copy this use of css unless you need to style a component from
   * a library we do not control
   */
  return (
    <ClassNames>
      {({ css }) => (
        <RouterLink
          href={href}
          className={css`
            color: ${match ? theme.color_theme : theme.color};
            font-size: calc(${(large ? '1.25' : '1')} * ${theme.fontSize_base});
            text-decoration: none;
            margin-left: ${theme.space_inset_md};
            ${match ? '' : `&:focus {
              color: ${theme.color_theme_focus};
              outline: 1px solid ${theme.borderColor_theme_focus};
              outline-offset: 2px;
            };`}
            &:hover {
              color: ${theme.color_theme_hover};
            }
            /* ':active' must be last, to follow LVHFA order:
            * https://developer.mozilla.org/en-US/docs/Web/CSS/:active
            */
            &:active {
              color: ${theme.color_theme_active};
            }
          `}
        >
          {children}
        </RouterLink>
      )
    }
    </ClassNames>
  );
}

NavigationLink.propTypes = propTypes;
NavigationLink.defaultProps = defaultProps;
export default withTheme(NavigationLink);
